/**
 * @directive sgTable
 * @param {Array} data - the original data array, consisting out of objects.
 *                        the objects will be enriched with a hideKey
 * @param {String} [hideKey] - Defaults to 'hide'. If this key is unavailable for some reason
 *                              you can provide a different key.
 * @param {Boolean} [combineFilters] - Can multiple filters be active or only one? Default: true
 * @param {Array} columns - Array consisting out of column objects
     * @param {String} [columns.type] - Type of column: ENUM: ['string', 'radio', 'multiSelect']. Omit if displayOnly
     * @param {String} columns.headerTitle - Label for the table header
     * @param {Boolean} [columns.sortable] - Can the column be sorted. Default: false
     * @param {String} columns.displayKey - Key of the data object which will determine cell value
     * @param {Function} [columns.displayKeyFn] - Function that transforms the displayKey into another string.
     *                                            Example: transforming ObjectId to a name
 *                                                Will receive three arguments:
 *                                                1. the displayKey value
 *                                                2. the item, AKA full row data, AKA data[n]
 *                                                3. the column, AKA columns[n]
 *
     * @param {Function} [columns.customFilter] - Custom filtering, will receive two arguments:
     *                                            the column and the current data item (example: project overview)
     * @param {String} [columns.template] - Link to the HTML template. The data item is available as 'item'
     *                                      The column is available as 'column'
     *
     * @param {String} [columns.hoverKey] - Key of the data object which will determine hove text
     * @param {Array} [columns.filterData] - Array of objects consisting out of option objects
     *                                    to be used in conjunction with 'radio' or 'multiSelect' filters
     * @param {String} [columns.optionDisplayKey] - Key on the option object to display a front-end value.
     *                                                  Defaults to 'value'.
     * @param {String} [column.optionValueKey] - Key on the option object which will be used for filtering.
     *                                        Defaults to 'value'.
     * @param {String} [columns.tdClass] - class to be added to the td element
     * @param {String} [columns.thClass] - class to be added to the th element
 *    @param {Function} [columns.columnClickHandler] - Callback if the cell is clicked. Will receive three params:
 *                                                      index (of ALL data, not just filtered data), item._id, item
 *    @param {Function} [columns.postFilterFn] - Callback after filter value is selected and after data is filtered.
 *                                                 Receives the column as argument.
 *    @param {Function} [columns.preFilterFn] - Callback after filter value is selected and before data is filtered.
 *                                                  Receives the column as argument.
 *                                                  Can be useful to reset the filter (values) of a different column.
 *
 *    @param {Object} [pagination] - If omitted, no pagination will be used
 *    @param {Number} [pagination.resultLimit] - Number of results to show per page, defaults to 10
 *    @param {Boolean} [pagination.resultLimitDropdown.enable] - Adds a dropdown for users to edit
 *                                                               the resultLimit clientSide - Defaults to 'false'
 *    @param {Array} [pagination.resultLimitDropdown.limit] - sets the accepted limit values
 *    @param {Number} [pagination.startPage] - Start page
 *
 * @example specsguard/app/client/app/user.html
 * */

(function () {
  angular
    .module('specsguardApp')
    .directive('sgTable', sgTable);

  function sgTable () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-mat-table/sg-table.html',
      controller: 'sgTableCtrl',
      controllerAs: '$sgTableCtrl',
      // Do not remove scope:true, this allows us to use parent controller aliases within this directive
      scope: true,
      bindToController: {
        data: '=',
        columns: '=',
        combineFilters: '=?',
        bulkMode: '=?',
        columnFilters: '=?',
        hideKey: '@?',
        pagination: '=?',
        defaultSort: '@?'
      }
    };
  }
})();
